/**
 * Service Form Module
 * Handles profit calculation and form validation for service forms
 */

(() => {
    "use strict";

    // Bootstrap form validation
    function initFormValidation() {
        // Fetch all the forms we want to apply custom Bootstrap validation styles to
        const forms = document.querySelectorAll(".needs-validation");

        // Loop over them and prevent submission only if invalid
        Array.from(forms).forEach((form) => {
            form.addEventListener(
                "submit",
                (event) => {
                    if (!form.checkValidity()) {
                        event.preventDefault();
                        event.stopPropagation();
                        form.classList.add("was-validated");
                        return false;
                    }
                    // Se o formulário é válido, permitir submissão normal
                    form.classList.add("was-validated");
                },
                false
            );
        });
    }

    // Função para calcular o lucro com base apenas no valor de venda
    function calculateProfit() {
        // Tentar primeiro os campos do modal, depois os campos normais
        let priceInput = document.getElementById("inputPriceServiceModal");
        let profitInput = document.getElementById("inputProfitServiceModal");

        // Se não encontrou os campos do modal, usar os campos normais
        if (!priceInput || !profitInput) {
            priceInput = document.getElementById("inputPriceService");
            profitInput = document.getElementById("inputProfitService");
        }

        if (priceInput && profitInput) {
            const rawPrice = priceInput.value || "";

            // Se não houver valor de venda, não há lucro para calcular
            if (!rawPrice.trim()) {
                profitInput.value = "";
                return;
            }

            const venda =
                parseFloat(
                    rawPrice
                        .toString()
                        .replace(/[^\d,]/g, "")
                        .replace(",", ".")
                ) || 0;

            // Com a remoção do Preço de custo, consideramos o lucro igual ao valor de venda
            profitInput.value = venda.toLocaleString("pt-BR", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            });
        }
    }

    // Função de debug para os campos do formulário
    function debugFormValues() {
        const priceInput = document.getElementById("inputPriceService");
        const profitInput = document.getElementById("inputProfitService");

        const precoValue = priceInput ? priceInput.value || "" : "";
        const lucroValue = profitInput ? profitInput.value || "" : "";
    }

    // Setup event listeners for form inputs
    function setupEventListeners() {
        // Adicionar event listeners para o campo de preço
        const priceInput = document.getElementById("inputPriceService");

        // Adicionar event listeners para campos do modal também
        const priceInputModal = document.getElementById(
            "inputPriceServiceModal"
        );

        if (priceInput) {
            priceInput.addEventListener("blur", function () {
                calculateProfit();
                debugFormValues();
            });
        }

        // Event listeners para campos do modal
        if (priceInputModal) {
            priceInputModal.addEventListener("blur", function () {
                calculateProfit();
                debugFormValues();
            });
        }

        // Event listener para o campo de lucro também
        const profitInput = document.getElementById("inputProfitService");
        if (profitInput) {
            profitInput.addEventListener("input", debugFormValues);
        }
    }

    // Setup modal event listeners
    function setupModalEventListeners() {
        // Também configurar quando o modal for aberto
        document.addEventListener("shown.bs.modal", function (event) {
            // Aguardar um pouco para garantir que o modal está totalmente renderizado
            setTimeout(function () {
                const priceInputModal = document.getElementById(
                    "inputPriceServiceModal"
                );
                if (
                    priceInputModal &&
                    !priceInputModal.hasAttribute("data-listeners-added")
                ) {
                    priceInputModal.addEventListener("blur", function () {
                        calculateProfit();
                    });
                    priceInputModal.setAttribute(
                        "data-listeners-added",
                        "true"
                    );
                }

                // Executar cálculo inicial
                calculateProfit();
            }, 100);
        });
    }

    // Initialize the service form functionality
    function init() {
        // Initialize form validation (only for non-modal forms)
        if (!document.querySelector(".service-modal-form")) {
            initFormValidation();
        }

        // Setup event listeners
        setupEventListeners();
        setupModalEventListeners();

        // Calcular lucro inicial se os campos já tiverem valores
        calculateProfit();
    }

    // Initialize when DOM is ready
    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", init);
    } else {
        init();
    }

    // Export functions for external use if needed
    window.ServiceForm = {
        calculateProfit,
        init,
    };
})();
